/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class ProgramsMajors extends SubCatAccordion implements IsubCatAccordion
    {
        typeCbs = [{ type: " 	Applied Mathematics, General", isChecked: false },
            { type: "Information Technology", isChecked: false },
            { type: "Bioengineering and Biomedical Engineering", isChecked: false },
            { type: "Computer Engineering, General", isChecked: false },
            { type: "Engineering Science", isChecked: false }
        ];

        public getSelectedTypes(): Array<string>
        {
            var selectedTypes = new Array<string>();
            this.selected = false;
            for ( var i in this.typeCbs )
            {
                if ( this.typeCbs[i].isChecked )
                {
                    selectedTypes.push( this.typeCbs[i].type );
                    this.selected = true;
                }
            }
            return selectedTypes;
        }
    }
} 